






























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import RoundModule from '@/store/modules/Round';

@Component
export default class Table extends Vue {
  @Prop() readonly head!: [];

  @Prop() readonly houseEdge!: number;

  @Prop() readonly currency!: string;

  @Prop() readonly componentKey!: any;

  @Prop() readonly selectCheckAll!: Function;

  RoundInstance = getModule(RoundModule, this.$store);

  created() {
    this.RoundInstance.selectAll(false);
  }

  handleCheckAll(event) {
    this.selectCheckAll(event.target.checked);
  }
}
